export default {
    title: 'Trendfinder',
    placeholder: 'Search for...'
}
